enum ReportPeriodType {
    CURRENT_MONTH = "current_month",
    LAST_MONTH = "last_month",
    CURRENT_QUARTER = "current_quarter",
    LAST_QUARTER = "last_quarter",
    CURRENT_YEAR = "current_year",
    LAST_YEAR = "last_year",
    CUSTOM_RANGE = "custom_range",
    START_END_DATE = "start_end_date",
    LAST_THIRTY_DAYS = "last_thirty_days",
    LAST_SIX_MONTHS = "last_six_months",
}

export default ReportPeriodType;
